document.addEventListener("DOMContentLoaded", function () {

  const blocks = document.querySelectorAll("footer .footer__block");

  blocks.forEach(block => {

    const title = block.querySelector(".h6");
    const content = block.querySelector("ul");

    if(!title || !content) return;

    title.addEventListener("click", function(){

      if (window.innerWidth > 768) return;

      const isOpen = block.classList.contains("active");

      // close all
      blocks.forEach(b=>{
        const ul = b.querySelector("ul");
        b.classList.remove("active");
        if(ul){
          ul.style.height = "0px";
        }
      });

      // open clicked
      if(!isOpen){
        block.classList.add("active");
        content.style.height = content.scrollHeight + "px";
      }

    });

  });

});